import { API_BASE } from "./api";

const AUTH_API = `${API_BASE}/auth`;

async function fetchWithTimeout(url, options = {}, timeoutMs = 5000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal,
    });
  } catch (error) {
    if (error?.name === "AbortError") {
      throw new Error(
        "Sign-in could not finish. Check that the backend is running on port 4000 and that Google OAuth allows http://localhost:3000."
      );
    }

    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
}

export async function signInWithGoogleIdToken(idToken) {
  const res = await fetchWithTimeout(`${AUTH_API}/google`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ id_token: idToken }),
  }, 10000);

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || "Backend did not complete sign-in. Please restart the backend and try again.");
  }

  return data;
}

export async function signOut() {
  const res = await fetchWithTimeout(`${AUTH_API}/logout`, {
    method: "POST",
    credentials: "include",
  }, 5000);

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || "Failed to sign out.");
  }
}

export async function fetchCurrentUser() {
  const res = await fetchWithTimeout(`${AUTH_API}/me`, {
    credentials: "include",
  });

  if (res.status === 401) {
    return null;
  }

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.message || "Failed to load current user.");
  }

  return data.user || null;
}
